export default "__VITE_ASSET__DOk1ZP$6__"